"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var mall_1 = require("../../model/mall");
var service_1 = require("../../../library/base/service");
var ProductList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ProductList, _super);
    function ProductList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '积分兑换商品列表';
        _this.code = '101152';
        _this.desc = '积分兑换商品列表';
        _this.requestParams = new mall_1.ProductListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ProductList;
}(service_1.BaseService));
exports.ProductList = ProductList;
//# sourceMappingURL=productList.js.map